export const DEFAULT_FILENAME = "pdfData";
export const EXPORT_AS_CSV_LABEL = "Export as CSV";
export const LOADING_TYPE = "linear";
export const ADD_ROW_POSITION = "first";
export const SEARCH_FIELD_ALIGNMENT = "right";
export const TOOLBAR_BUTTON_ALIGNMENT = "right";
export const ACTIONS_COLUMN_INDEX = 0;
export const EXPORT_ALL_DATA = true;
export const COLUMNS_BUTTON = true;

export const EMPTY_DATA_SOURCE_MESSAGE = "No records to display";
export const ADD_TOOLTIP = "Add";
export const DELETE_TOOLTIP = "Delete";
export const EDIT_TOOLTIP = "Edit";
export const FILTER_TOOLTIP = "Filter";
export const DELETE_TEXT = "Are you sure you want to delete this row?";
export const CANCEL_TOOLTIP = "Cancel";
export const SAVE_TOOLTIP = "Save";
export const PLACEHOLDER = "Drag headers";
export const GROUPED_BY = "Grouped by:";
export const ACTIONS = "Actions";
export const LABEL_DISPLAYED_ROWS = `{from}-{to} of {count}`;
export const LABEL_ROWS_SELECT = "rows";
export const LABEL_ROWS_PER_PAGE = "Rows per page:";
export const FIRST_ARIA_LABEL = "First Page";
export const FIRST_TOOLTIP = "First Page";
export const PREVIOUS_ARIA_LABEL = "Previous Page";
export const PREVIOUS_TOOLTIP = "Previous Page";
export const NEXT_ARIA_LABEL = "Next Page";
export const NEXT_TOOLTIP = "Next Page";
export const LAST_ARIA_LABEL = "Last Page";
export const LAST_TOOLTIP = "Last Page";
export const ADD_REMOVE_COLUMNS = "Add or remove columns";
export const N_ROWS_SELECTED = `{0} selected rows`;
export const SHOW_COLUMNS_TITLE = "Show Columns";
export const SHOW_COLUMNS_ARIA_LABEL = "Voir les colonnes";
export const EXPORT_TITLE = "Export";
export const EXPORT_ARIA_LABEL = "Export";
export const EXPORT_CSV_NAME = "Export as CSV";
export const SEARCH_TOOLTIP = "Search";
export const SEARCH_PLACEHOLDER = "Search";
export const ACTIONS_FONT_SIZE = "0.9rem";
export const DELETE_LABEL = "Διαγραφή";
export const EDIT_LABEL = "Επεξεργασία";
